import { useQuery } from "@tanstack/react-query";
import { fetchActivityFeedbackParticipants } from "PFCore/services/activities";
import { Collection, Id, QueryOptions } from "PFTypes";
import { ActivityParticipant } from "PFTypes/activity_participant";

import { activityKeys } from "./query_keys";

export type FeedbackParticipantsResponseType = Collection<ActivityParticipant[]>;

export const useActivityFeedbackParticipants = (
  activityId?: Id,
  options?: QueryOptions<FeedbackParticipantsResponseType>
) =>
  useQuery<FeedbackParticipantsResponseType>({
    queryKey: activityKeys.feedbackParticipants(activityId),
    queryFn: () => fetchActivityFeedbackParticipants(activityId!),
    retry: false,
    staleTime: 0,
    enabled: !!activityId,
    ...options
  });
